import React, { useState } from "react";
import "../Footer/Footer.css";
import CtaBar from "../Cta/Cta";


const Footer = () => {
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const phoneClick = () => {
    window.location.href = "tel:+919654945825";
  };

  return (
    <>
      <footer className="footer">
        <div className="footer-content">
          
          {/* ✅ LEFT SIDE LOGO */}
          <div className="footer-left">
           
          </div>

          {/* ✅ RIGHT SIDE DETAILS */}
          <div className="footer-right">
           <img
              src="/logo.webp"
              alt="Irish Group Logo"
              className="footer-logo"
              loading="lazy"
            />
            <div className="footer-con">
              <p className="f-pp">Contact Number</p>
              <p className="num" onClick={phoneClick}>
                +91 96549 45825
              </p>
            </div>

            <div className="footer-con">
              <p className="f-pp">Location</p>
              <p className="num2">
                Gh-04A, near Arihant Abode, Sector 10, Vaidpura, Greater Noida,
                Uttar Pradesh 203207
              </p>
            </div>

            <div className="footer-con">
              <p className="f-pp">Project Rera</p>
              <p className="num2">UPRERAPRJ503189/03/2024</p>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <p className="disclaimer-f">
          © {new Date().getFullYear()} Irish Group. This website is operated by
          an authorized channel partner of Irish Group, UP RERA Registration No.
          UPRERAPRJ503189/03/2024. The information provided on this website is
          intended for informational purposes only. All images are for
          illustrative purposes. Prices are subject to change without prior
          notice, and the availability of properties may vary. By providing your
          contact information, you may receive updates via the registered mobile
          number and email.
        </p>

        <div className="footer-links">
          <a href="/privacy" className="footer-link">
            Disclaimer & Privacy Policy
          </a>
        </div>

        {/* Modal */}
        {showModal && (
          <div className="modal">
            <div className="modal-content">
              <span className="close-button" onClick={handleCloseModal}>
                &times;
              </span>
              <img
                src="details.jpeg"
                loading="lazy"
                alt="Agent RERA Details"
              />
            </div>
          </div>
        )}

        <CtaBar />
      </footer>
    </>
  );
};

export default Footer;